import type { LiteQuote, QuoteItemBaqData } from '@frontend/api';

import { RootState } from 'store/configureStore';

import { types } from './actions';
import type {
  EmailNotificationSetting,
  EmailTemplate,
  ShippingInfo,
} from './types';

export type FinalizeModalState = {
  isFetching: boolean;
  isFinalizeModalOpen: boolean;
  isResend: boolean;
  emailNotificationSettings: EmailNotificationSetting[];
  emailTemplates: EmailTemplate[];
  quoteHeader: LiteQuote;
  quoteItems: QuoteItemBaqData[];
  shippingInfo: ShippingInfo | undefined;
};

const initialState: FinalizeModalState = {
  isFetching: true,
  isFinalizeModalOpen: false,
  isResend: false,
  emailNotificationSettings: [],
  emailTemplates: [],
  quoteHeader: {} as LiteQuote,
  quoteItems: [],
  shippingInfo: undefined,
};

type ActionType = {
  type: string;
  payload?: any;
};

const reducer = (
  state: FinalizeModalState = initialState,
  action: ActionType,
): FinalizeModalState => {
  const { payload, type } = action;
  switch (type) {
    case types.FINALIZE_MODAL_CLOSE:
      return {
        ...initialState,
        isFinalizeModalOpen: false,
      };
    case types.FINALIZE_MODAL_OPEN:
      return {
        ...initialState,
        isFetching: true,
        isFinalizeModalOpen: true,
      };
    case types.FINALIZE_MODAL_INIT_SUCCESS:
      return {
        ...state,
        emailNotificationSettings: payload.emailNotificationSettings,
        emailTemplates: payload.emailTemplates,
        isFetching: false,
        isResend: payload.isResend,
        quoteHeader: payload.quoteHeader,
        quoteItems: payload.quoteItems,
        shippingInfo: payload.shippingInfo,
      };
    case types.EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_SUCCESS:
      return {
        ...state,
        emailNotificationSettings: payload.emailNotificationSettings,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState): FinalizeModalState =>
  state.modules.common.modals.finalizeModal;

export const getIsFetching = (state: RootState) => getScope(state).isFetching;

export const getIsFinalizeModalOpen = (state: RootState) =>
  getScope(state).isFinalizeModalOpen;

export const getEmailNotificationSettings = (state: RootState) =>
  getScope(state).emailNotificationSettings;

export const getQuoteHeader = (state: RootState) => getScope(state).quoteHeader;

export const getQuoteItems = (state: RootState) => getScope(state).quoteItems;

export const getEmailTemplates = (state: RootState) =>
  getScope(state).emailTemplates;

export const getShippingInfo = (state: RootState) =>
  getScope(state).shippingInfo;

export const getIsResend = (state: RootState) => getScope(state).isResend;
